import moment from "moment"
import Service from "../../../Services/index";

const rrPayoff = {
    namespaced: true,
    state: {
        RRPayoffList:[],
        RRPayoffData : [],
        RRProjectList : [],
        //transaction
        transactions : {
            cash:{
                transaction_type_id : 3,
                ref_no: "",
                date : "",
                bank_name: "",
                bank_branch: "",
                amount : "",
                description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                bank_id : "",
                bank :null,
            },
            cheque : [{
                transaction_type_id : 1,
                ref_no: "",
                date : "",
                bank_name: "",
                bank_branch: "",
                amount : "",
                description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                bank_id : "",
                bank :null,
            }],
            transfer : [{
                transaction_type_id : 2,
                ref_no: "",
                date : "",
                bank_name: "",
                bank_branch: "",
                amount : "",
                description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                bank_id : "",
                bank :null,
            }],
            checkCash: false,
            checkCheque: false,
            checkTransfer: false,
        },
        //form
        form:{
            id : "",
            vendor:"",
            payment_type : "",
            project : "",
            receive_date: null,
            is_sell: true,
            calc_tax: 0,
            offset_amount: 0,
            pledge_amount: 0,
            fee_amount: 0,
            tax_amount: 0,
            overpay : "",
            arrears : "",
            status : null,
            note : "",
            rr_payoff_details : [],
            rr_project_details : [],
            rr_payoff_other_details : [{
                index : "",
                account_id: "",
                payment_details_id: "",
                account_details_id: "",
                name: "",
                account_number: "",
                amount : "",
                account : null,
            }],
            payoff_purchase_details : [{
                po_id : "",
                amount : "",
                po : null,

            }],
            total_amount : 0,
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search:{
            vendor: "",
            total_amount: "",
            receive_date: [],
            payment_type: "",
            no : '',
            account : '',
        },
        rr_vendor : [],
        vendor : [],
        po_vendor : [],
        //cheque
        cheque_form : {
            bank_name : "",
            bank_branch : "",
            ref_no : "",
            status : "",
            approve_date : "",
            amount : "",
            date : ""
        }
    },
    mutations: {
        GET_RR_PAYOFF:(state,res)=>{
            state.RRPayoffList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        },
        GET_RR_PAYOFF_BY_ID:(state,res)=>{
            //set form
            state.form  = res;
            let rr_order = [];
            //rr_payoff_details
            if(res.payment_type == 1){
                if(res.rr_payoff_details.length > 0){
                    res.rr_payoff_details.forEach(data=>{
                        rr_order.push(data.rr_order);
                    });
                    state.rr_vendor = rr_order;
                }
            }
            else{
                //rr_payoff_other_details
                console.log(res.rr_payoff_other_details)
                state.form.rr_payoff_other_details = res.rr_payoff_other_details
                state.form.rr_payoff_other_details.push({
                    index : "",
                    account_id: "",
                    payment_details_id: "",
                    account_details_id: "",
                    name: "",
                    account_number: "",
                    amount : "",
                    account : null,
                })
            }
            //set transactions
            state.transactions = {
                cash:{
                    transaction_type_id : 3,
                    ref_no: "",
                    date : "",
                    bank_name: "",
                    bank_branch: "",
                    amount : "",
                    description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                    bank_id : "",
                    bank :null,
                },
                cheque : [],
                transfer : [],
                checkCash: false,
                checkCheque: false,
                checkTransfer: false,
            };
            //store in array
            if(res.transactions.length > 0){
                res.transactions.forEach(transaction=>{
                    if(transaction.transaction_type_id == 1){ //cheque
                        state.transactions.checkCheque = true;
                        state.transactions.cheque = [
                            ...state.transactions.cheque,
                            {
                                transaction_type_id : 1,
                                ref_no: transaction.ref_no,
                                date : transaction.date,
                                bank_name: transaction.bank_name,
                                bank_branch: transaction.bank_branch,
                                amount : transaction.amount,
                                description: transaction.description,
                                bank_id : transaction.bank_id,
                                bank : transaction.bank,
                            }
                        ]
                    }
                    if(transaction.transaction_type_id == 2){ //transfer
                        state.transactions.checkTransfer = true;
                        state.transactions.transfer = [
                            ...state.transactions.transfer,
                            {
                                transaction_type_id : 2,
                                ref_no: transaction.ref_no,
                                date : transaction.date,
                                bank_name: transaction.bank_name,
                                bank_branch: transaction.bank_branch,
                                amount : transaction.amount,
                                description: transaction.description,
                                bank_id : transaction.bank_id,
                                bank : transaction.bank,
                            }
                        ]
                    }
                    if(transaction.transaction_type_id == 3){ //cash
                        state.transactions.checkCash = true;
                        state.transactions.cash = {
                            transaction_type_id : 3,
                            ref_no: transaction.ref_no,
                            date : transaction.date,
                            bank_name: transaction.bank_name,
                            bank_branch: transaction.bank_branch,
                            amount : transaction.amount,
                            description: transaction.description,
                            bank_id : transaction.bank_id,
                            bank : transaction.bank,
                        }
                    }
                })
            }
            //new data
            if(state.transactions.checkCash == false){
                state.transactions.cash = {
                    transaction_type_id : 3,
                        ref_no: "",
                        date : "",
                        bank_name: "",
                        bank_branch: "",
                        amount : "",
                        description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                        bank_id : "",
                        bank :null,
                }
            }
            if(state.transactions.cheque  == false){
                state.transactions.cheque  = [{
                    transaction_type_id : 1,
                    ref_no: "",
                    date : "",
                    bank_name: "",
                    bank_branch: "",
                    amount : "",
                    description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                    bank_id : "",
                    bank :null,
                }]
            }
            if(state.transactions.transfer   == false){
                state.transactions.transfer = [{
                    transaction_type_id : 2,
                    ref_no: "",
                    date : "",
                    bank_name: "",
                    bank_branch: "",
                    amount : "",
                    description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                    bank_id : "",
                    bank :null,
                }]
            }

        },
        GET_RR_VENDOR : (state,res)=>{
            state.rr_vendor = res;
        },
        GET_PO_VENDOR : (state,res)=>{
            state.po_vendor = res;
            console.log(state.po_vendor);
        },
        GET_VENDOR : (state,res)=>{
            state.vendor = res;
        },
        CLEAR_FORM_DATA:state=>{
            let date = moment().format("YYYY-MM-DD");
            state.rr_vendor = [];
            state.vendor = [];
            state.po_vendor = [];
            state.form = {
                id : "",
                vendor:"",
                payment_type : "",
                project :"",
                receive_date: date,
                is_sell: true,
                calc_tax: 0,
                offset_amount: 0,
                pledge_amount: 0,
                fee_amount: 0,
                tax_amount: 0,
                overpay : "",
                arrears : "",
                status : null,
                note : "",
                rr_payoff_details : [],
                rr_project_details : [],
                rr_payoff_other_details : [{
                    index : "",
                    account_id: "",
                    payment_details_id: "",
                    account_details_id: "",
                    name: "",
                    account_number: "",
                    amount : "",
                    account : null,
                }],
                payoff_purchase_details : [{
                    po_id : "",
                    amount : "",
                    po : null,

                }],
                total_amount : 0,
            },
                //transactions
                state.transactions = {
                cash:{
                    transaction_type_id : 3,
                        ref_no: "",
                        date : "",
                        bank_name: "",
                        bank_branch: "",
                        amount : "",
                        description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                        bank_id : "",
                        bank :null,
                },
                cheque : [{
                    transaction_type_id : 1,
                    ref_no: "",
                    date : "",
                    bank_name: "",
                    bank_branch: "",
                    amount : "",
                    description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                    bank_id : "",
                    bank :null,
                }],
                    transfer : [{
                    transaction_type_id : 2,
                    ref_no: "",
                    date : "",
                    bank_name: "",
                    bank_branch: "",
                    amount : "",
                    description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                    bank_id : "",
                    bank :null,
                }],
                    checkCash: false,
                    checkCheque: false,
                    checkTransfer: false,
            }
        },
        CLEAR_SEARCH:(state)=>{
            state.search = {
                vendor: "",
                total_amount: "",
                receive_date: [],
                payment_type: "",
                no : '',
                account : '',
            }
        },
        //other_details
        ADD_OTHER_DETAILS: (state) => {
            state.form.rr_payoff_other_details = [
                ...state.form.rr_payoff_other_details,
                {
                    index : "",
                    account_id: "",
                    payment_details_id: "",
                    account_details_id: "",
                    name: "",
                    account_number: "",
                    amount : "",
                    account : null,
                }
            ];
        },
        REMOVE_OTHER_DETAILS: (state, index) => {
            state.form.rr_payoff_other_details = state.form.rr_payoff_other_details.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        },
        //purchase_order_details
        ADD_PURCHASE_DETAILS: (state) => {
            state.form.payoff_purchase_details = [
                ...state.form.payoff_purchase_details,
                {
                    po_id : "",
                    amount : "",
                    po : null,
                }
            ];
        },
        REMOVE_PURCHASE_DETAILS: (state, index) => {
            state.form.payoff_purchase_details = state.form.payoff_purchase_details.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        },
        //get cheque
        GET_CHEQUE_RR_PAYOFF(state,res){
            state.cheque_form = res;
        },
        //get project payment
        GET_PROJECT_PAYMENT(state,res){
            state.RRProjectList = res;
        },
        GET_PROJECT_PAYMENT_DETAILS (state,res){
            state.form.rr_project_details = res;
        }
    },
    actions: {
        getRRpayoff({commit},page = 1) {
            return Service.RRPayoff.getRRPayoff(page)
                .then(data => {
                    commit("GET_RR_PAYOFF", data)
                })
        },
        getRRPayoffIdfAll(){
            return Service.RRPayoff.getRRPayoffIdfAll();
        },
        getRRpayoffById({commit},id){
            return Service.RRPayoff.getRRPayoffById(id)
                .then(data => {
                    console.log(data);
                    commit("GET_RR_PAYOFF_BY_ID", data);
                    commit("GET_RR_VENDOR" ,data.rr_payoff_details);
                    commit("GET_PROJECT_PAYMENT_DETAILS",data.rr_project_details);
                })
        },
        saveRRpayoff({state,commit},id){
            let data = {
                no : state.form.no,
                vendor_id : "",
                payment_type : state.form.payment_type,
                receive_date : "",
                project_id : state.form.project ? state.form.project.id : null,
                is_sell : state.form.is_sell,
                calc_tax : state.form.calc_tax,
                offset_amount : state.form.offset_amount,
                pledge_amount : state.form.pledge_amount,
                fee_amount : state.form.fee_amount,
                tax_amount : state.form.tax_amount,
                overpay : state.form.overpay,
                arrears : state.form.arrears,
                note : state.form.note,
                transactions : state.form.transactions,
                rr_payoff_details : state.form.rr_payoff_details,
                rr_payoff_other_details : state.form.rr_payoff_other_details,
                rr_project_details : state.form.rr_project_details,
                status : state.form.status
            };
            if(state.form.vendor){
                data.vendor_id = state.form.vendor.id;
            }
            if(state.form.receive_date){
                data.receive_date = moment(state.form.receive_date).format("YYYY-MM-DD");
            }
            console.log(data);
            if(!id){
                return Service.RRPayoff.createRRPayoff(data);
            }else{
                return Service.RRPayoff.updateRRPayoff(id,data);
            }
        },
        deleteRRpayoffById({commit},id){
            return Service.RRPayoff.deleteRRPayoff(id);
        },
        getRRvendor({commit},data){
            return Service.RRPayoff.getRRFromVendor(data).then(res=>{
                console.log(data);
                commit("GET_RR_VENDOR",res)
            });
        },
        getVendorFormPayoff({commit}){
            return Service.RRPayoff.getVendorPayoff().then(res=>{
                commit("GET_VENDOR",res);
            })
        },
        updateCsNo({commit},data){
          return Service.RRPayoff.updateCsNo(data);
        },
        clearData({commit}){
            commit("CLEAR_FORM_DATA");
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        },
        addOtherDetails({commit}){
            commit("ADD_OTHER_DETAILS");
        },
        removeOtherDetails({commit},index){
            commit("REMOVE_OTHER_DETAILS",index)
        },
        search({commit},{page=1,data}){
            console.log(data);
            return Service.RRPayoff.searchRRPayoff(page,data).then(res=>{
                commit("GET_RR_PAYOFF",res);
            })
        },
        //purchase details
        getVendorByfPo({commit}){
            return Service.RRPayoff.getVendorByfPo().then(res=>{
                commit("GET_VENDOR",res);
            });
        },
        getPOByVendor({commit},vendor_id){
            return Service.RRPayoff.getPOByVendor(vendor_id).then(res=>{
                console.log(res);
                commit("GET_PO_VENDOR",res);
            });
        },
        addPurchaseDetails({commit}){
            commit("ADD_PURCHASE_DETAILS");
        },
        removePurchaseDetails({commit},index){
            commit("REMOVE_PURCHASE_DETAILS",index);
        },
        generateCS({commit},date){
            return Service.RRPayoff.generateCS(date);
        },

        //cheque
        getChequeRRPayoff({commit},page=1){
            return Service.RRPayoff.getChequeRRPayoff(page);
        },
        updateChequeRRPayoff({commit},{id,data}){
            return Service.RRPayoff.updateChequeRRPayoff(id,data);
        },
        showChequeRRPayoff({commit},id){
            return Service.RRPayoff.showChequeRRPayoff(id).then(res=>{
                console.log(res);
                commit("GET_CHEQUE_RR_PAYOFF",res);
            })
        },
        searchChequeRRPayoff({commit},data){
            return Service.RRPayoff.searchChequeRRPayoff(data);
        },
        deleteChequeRRPayoff({commit},id){
            return Service.RRPayoff.deleteChequeRRPayoff(id);
        },

        //project payment
        getProjectList({commit},vendor_id){
            return Service.RRPayoff.getProjectByVendor(vendor_id).then(res=>{
                commit("GET_PROJECT_PAYMENT",res);
            });
        },
        setProjectDetails ({commit} , data){
            console.log(data);
            commit("GET_PROJECT_PAYMENT_DETAILS",data);
        }
    }
};

export default rrPayoff
